const ConferenceOverview = () => {
  return (
    <div>
        <div className="gap-[46px] flex flex-col items-center justify-center bg-black-900_01 px-14 py-48 md:p-5">
            <h2 className="desktop:size-heading7xl tablet:size-heading7xl mobile:text-[32px] bold heading ui text-shadow-ts3 text-center">
                <div className="font-monasanssemicondensed font-bold text-[48px] mobile:!text-[32px]">AI, XR, CGI, Metaverse,</div>
                <div className="font-monasanssemicondensed font-bold text-[48px] mobile:!text-[32px] tablet:leading-[40px]">Virtual Art, and more.</div>
            </h2>
            <div className="flex justify-center md:w-full ml-[20px]">
                <div className="flex w-full flex-col items-center">
                    <div className="flex justify-between mobile:gap-[39px] self-stretch grid-cols-4 desktop:gap-[100px] tablet:gap-[60px] grid mobile:grid-cols-2">
                        <div>
                            <h3
                                className="size-heading9xl heading ui text-shadow-ts3 bg-gradient15 bg-clip-text uppercase !text-transparent"
                                style={{
                                backgroundImage: "linear-gradient(152deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0.2) 100%)",
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",
                                textShadow: "0px 20px 50px rgba(0, 0, 0, 0.7)",
                            }}>
                                500+
                            </h3>
                            <p className="text-[18px] heading ui tracking-[1.00px] uppercase !text-white-a700_b2 sm:w-full">
                                attendees
                            </p>
                        </div>
                        <div>
                            <h4 className="size-heading9xl heading ui text-shadow-ts3 bg-gradient15 bg-clip-text uppercase !text-transparent"
                                style={{
                                backgroundImage: "linear-gradient(152deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0.2) 100%)",
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",
                                textShadow: "0px 20px 50px rgba(0, 0, 0, 0.7)",
                            }}>
                                30+
                            </h4>
                            <p className="size-text5xl heading ui tracking-[1.00px] uppercase !text-white-a700_b2 sm:w-full">
                                speakers
                            </p>
                        </div>
                        <div>
                            <h5 className="size-heading9xl heading ui text-shadow-ts3 bg-gradient15 bg-clip-text uppercase !text-transparent"
                                style={{
                                backgroundImage: "linear-gradient(152deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0.2) 100%)",
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",
                                textShadow: "0px 20px 50px rgba(0, 0, 0, 0.7)",
                            }}>
                                20+
                            </h5>
                            <p className="size-text5xl heading ui tracking-[1.00px] uppercase !text-white-a700_b2 sm:w-full">
                                sessions
                            </p>
                        </div>
                        <div>
                            <h6 className="size-heading9xl heading ui text-shadow-ts3 bg-gradient15 bg-clip-text uppercase !text-transparent"
                                style={{
                                backgroundImage: "linear-gradient(152deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0.2) 100%)",
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",
                                textShadow: "0px 20px 50px rgba(0, 0, 0, 0.7)",
                            }}>
                                12+
                            </h6>
                            <p className="size-text5xl heading ui tracking-[1.00px] uppercase !text-white-a700_b2 sm:w-full">
                                TOPICS
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
};

export default ConferenceOverview;
